import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ef0793d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = {
  class: "description-header-content"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "区域权限", -1));
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "角色信息", -1));
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "权限信息", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "操作日志", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_form_page = _resolveComponent("form-page");
  const _component_table_page = _resolveComponent("table-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, "用户：" + _toDisplayString($data.user.userCode) + "（" + _toDisplayString($data.user.userName) + "）", 1)]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
      gutter: 10,
      class: "description-header-content-line content-line"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "联系电话：" + _toDisplayString($data.user.phone), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "生效日期：" + _toDisplayString($data.user.validateDate), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "失效日期：" + _toDisplayString($data.user.invalidateDate), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 10,
      class: "description-header-content-line content-line"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "登录方式：" + _toDisplayString($data.user.loginType), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_ctx.$hasPermission('user_enable') ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode(" 使用状态： "), _createVNode(_component_el_switch, {
          modelValue: $data.user.enabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.user.enabled = $event),
          loading: $data.switchLoading,
          "before-change": $options.changeEnabled
        }, null, 8, ["modelValue", "loading", "before-change"])])) : (_openBlock(), _createElementBlock("span", _hoisted_4, "使用状态：" + _toDisplayString($data.user.enabled ? '使用中' : '已禁用'), 1))]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_ctx.$hasPermission('user_lock') ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(" 锁定状态： "), _createVNode(_component_el_switch, {
          modelValue: $data.user.locked,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.user.locked = $event),
          loading: $data.switchLoading,
          "before-change": $options.changeLock
        }, null, 8, ["modelValue", "loading", "before-change"])])) : (_openBlock(), _createElementBlock("span", _hoisted_6, "锁定状态：" + _toDisplayString($data.user.locked ? '已锁定' : '未锁定'), 1))]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 10,
      class: "description-header-content-line"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "最后登录时间：" + _toDisplayString($data.user.lastLoginTime), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 16
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, "备注：" + _toDisplayString($data.user.remark), 1)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_hoisted_7, _createVNode(_component_el_divider), $data.user.areaList && $data.user.areaList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.user.areaList, area => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: area.id,
        effect: "dark",
        style: {
          "margin-right": "5px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(`${area.name}（${area.code}）`), 1)]),
        _: 2
      }, 1024);
    }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
      key: 1,
      description: "暂无数据",
      "image-size": 80,
      style: {
        "--el-empty-padding": "0"
      }
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: $options.toDeptBindUser
      }, {
        default: _withCtx(() => [_createTextVNode("去绑定")]),
        _: 1
      }, 8, ["onClick"])), [[_directive_permission, 'dept_bind_user']])]),
      _: 1
    }))]),
    _: 1
  }), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_hoisted_9, _createVNode(_component_el_divider), $data.roles && $data.roles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, role => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: role.roleId,
        effect: "dark",
        style: {
          "margin-right": "5px"
        },
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(role.roleName), 1)]),
        _: 2
      }, 1024);
    }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
      key: 1,
      description: "暂无数据",
      "image-size": 80,
      style: {
        "--el-empty-padding": "0"
      }
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: $options.toBindUser
      }, {
        default: _withCtx(() => [_createTextVNode("去绑定")]),
        _: 1
      }, 8, ["onClick"])), [[_directive_permission, 'role_bind_user']])]),
      _: 1
    }))]),
    _: 1
  }), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_hoisted_11, _createVNode(_component_el_divider), _createVNode(_component_table_page, {
      fetchApi: _ctx.$api.uac.permission.getUserPermission,
      searchParams: {
        'userId': this.userId,
        filterButton: false
      },
      columns: $data.permissionColumns,
      showPagination: false,
      rowKey: "permissionId",
      class: "content-page",
      columnSetting: false,
      selectionEnable: false
    }, null, 8, ["fetchApi", "searchParams", "columns"])]),
    _: 1
  }), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_hoisted_12, _createVNode(_component_el_divider), _createVNode(_component_table_page, {
      fetchApi: _ctx.$api.log.logData.detail,
      searchParams: {
        'operatorId': this.userId
      },
      columns: $data.logColumns,
      selectionEnable: false,
      class: "content-page",
      columnSetting: false
    }, null, 8, ["fetchApi", "searchParams", "columns"])]),
    _: 1
  })]);
}